
import { FIREARM_STORAGE_LOCATION_PLI_METADATA } from './firearm-storage-location-pli.metadata';
import { FirearmStorageLocationPLI } from './firearm-storage-location-pli.model';
import { FirearmStorageLocationEntityDecorator } from './firearm-storage-location.decorator';
import { FirearmStorageLocation } from './firearm-storage-location.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class FirearmStorageLocationPLIEntityDecoratorBase extends GenericEntityDecorator<FirearmStorageLocationPLI, number> {
  constructor() {
    super(FIREARM_STORAGE_LOCATION_PLI_METADATA, {
      get firearmStorageLocation(): EntityDecorator<FirearmStorageLocation, number> {
        return new FirearmStorageLocationEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.firearmStorageLocationPLIId == null) {
      return null;
    }
    return parseInt(params.firearmStorageLocationPLIId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: FirearmStorageLocationPLI): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




